import React from 'react';
import { Phone } from 'lucide-react';
import { AGENT, BAYLEYS_LOGO } from '@/data/agent';
import { LANDING } from '@/constants/testIds';

const TopBar = () => {
  return (
    <header
      data-testid={LANDING.topbar}
      className="w-full bg-bayleys-navy text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 h-16 flex items-center justify-between">
        {/* Left: Bayleys logo + licence */}
        <div
          data-testid={LANDING.topbarLogo}
          className="flex items-center gap-4"
        >
          <img
            src={BAYLEYS_LOGO}
            alt="Bayleys — Altogether Better"
            className="h-9 sm:h-10 w-auto"
          />
          <span className="hidden md:inline-block h-6 w-px bg-white/25" />
          <span className="hidden md:inline-block text-[11px] tracking-widest uppercase text-white/65">
            Mackys Real Estate Ltd
          </span>
        </div>

        {/* Right: Phone CTA */}
        <a
          data-testid={LANDING.topbarPhone}
          href={AGENT.phoneHref}
          className="group inline-flex items-center gap-2 text-sm sm:text-[15px] font-medium hover:text-bayleys-gold transition-colors duration-200"
        >
          <Phone className="w-4 h-4" strokeWidth={2} />
          <span className="hidden sm:inline">{AGENT.phone}</span>
          <span className="sm:hidden">Call</span>
        </a>
      </div>
    </header>
  );
};

export default TopBar;
